import { Injectable } from '@angular/core';

export interface ListState {
  currentPage: number;
  pageSize: number;
  sortBy?: string | null;
  sortDirection?: 'asc' | 'desc' | null;
  filters?: any;
  collapseIsOpen?: boolean;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root',
})
export class ListStateStackService {
  private stateStacks: Map<string, ListState[]> = new Map();

  pushState(routeName: string, state: ListState): void {
    if (!this.stateStacks.has(routeName)) {
      this.stateStacks.set(routeName, []);
    }
    this.stateStacks.get(routeName)!.push(state);
  }
  
  popState(routeName: string): ListState | null {
    const stack = this.stateStacks.get(routeName);
    if (stack && stack.length > 0) {
      return stack.pop() || null;
    }
    return null;
  }

  peekState(routeName: string): ListState | null {
    const stack = this.stateStacks.get(routeName);
    if (stack && stack.length > 0) {
      return stack[stack.length - 1];
    }
    return null;
  }

  hasState(routeName: string): boolean {
    const stack = this.stateStacks.get(routeName);
    return stack !== undefined && stack.length > 0;
  }

  clearStack(routeName: string): void {
    this.stateStacks.delete(routeName);
  }

  clearAllStacks(): void {
    this.stateStacks.clear();
  }

  getStackSize(routeName: string): number {
    const stack = this.stateStacks.get(routeName);
    return stack ? stack.length : 0;
  }
}
